import {ModalComponents} from 'constants/Modals';
import {Routes} from 'constants/routes';

import {useState} from 'react';

import Button from 'components/Button/Button';
import Icon from 'components/Icon/Icon';
import useOnClickOutside from 'hooks/useOnClickOutside';
import {useSetGlobalState} from 'hooks/useSetGlobalState';
import {useNavigate} from 'react-router-dom';
import {setModalAC} from 'store/modal/modalSlice';
import './SettingsDropdown.scss';

const SettingsDropdown = () => {
  const [showActions, setShowActions] = useState(false);
  const dispatch = useSetGlobalState();
  const navigate = useNavigate();

  const handleLogout = () => {
    dispatch(setModalAC(ModalComponents.LOGOUT_CONFIRMATION));
    setShowActions(false);
  };

  const handleProfileClick = () => navigate(Routes.PROFILE);

  const {containerRef} = useOnClickOutside<HTMLDivElement>(() => {
    setShowActions(false);
  });

  return (
    <div className="settings-dropdown" data-testid="settings-dropdown" ref={containerRef}>
      <Button
        variant="empty"
        data-testid="settings-dropdown-action"
        onClick={() => setShowActions((currState) => !currState)}
      >
        <Icon icon="settings" />
      </Button>
      {showActions && (
        <div className="settings-dropdown__actions" data-testid="settings-dropdown-options">
          <Button variant="empty" className="settings-dropdown__profile" onClick={handleProfileClick}>
            My profile
          </Button>
          <Button variant="empty" className="settings-dropdown__logout" onClick={handleLogout}>
            <Icon icon="logout" />
            Logout
          </Button>
        </div>
      )}
    </div>
  );
};

export default SettingsDropdown;
